export default __webpack_public_path__ + "static/media/Water Bath.ff5d2857.svg";